import { InjectionToken } from '@angular/core';
import { FilingLoaderStrategy } from './filing-loader.strategy';

/**
 * DI token for the active filing-form loader strategy.
 *
 * Consumers (container, overlay component, loader outlet) inject this token —
 * not a concrete strategy class. The concrete class is selected at the
 * composition root (`app.config.ts`) based on `environment.filingLoaderMode`
 * and the registry at `filing-loader.registry.ts`.
 *
 * @see docs/ui/loaders/filing/README.md
 */
export const FILING_LOADER_STRATEGY = new InjectionToken<FilingLoaderStrategy>(
  'FILING_LOADER_STRATEGY',
);
